export const LAST_TX_LANG_STORAGE_KEY = "lastTxLang";
export const DEFAULT_TX_LOCALE = "de_DE";
export const SUPPORTED_TX_LOCALES = ["de_DE", "en_GB"];

export const normalizeTxLocale = (storedLocale: string | null): string => {
    if (!storedLocale) return DEFAULT_TX_LOCALE;
    if (SUPPORTED_TX_LOCALES.includes(storedLocale)) return storedLocale;

    // Legacy values like "de" or "en" → match by language part
    const languagePart = storedLocale.split(/[-_]/)[0].toLowerCase();
    const matchingLocale = SUPPORTED_TX_LOCALES.find(
        (locale) => locale.split(/[-_]/)[0].toLowerCase() === languagePart
    );
    return matchingLocale ?? DEFAULT_TX_LOCALE;
};
